// Activity tracking service
class ActivityService {
  constructor() {
    this.activities = this.loadActivities();
  }

  loadActivities() {
    const stored = localStorage.getItem('fciveria_activities');
    return stored ? JSON.parse(stored) : [];
  }

  saveActivities() {
    localStorage.setItem('fciveria_activities', JSON.stringify(this.activities));
  }

  addActivity(type, action, details = {}) {
    const activity = {
      id: Date.now(),
      type, // 'news', 'match', 'standing'
      action, // 'created', 'updated', 'deleted', 'published', 'unpublished'
      details,
      timestamp: new Date().toISOString(),
      user: 'Admin' // In a real app, this would come from auth context
    };

    this.activities.unshift(activity);
    
    // Keep only last 50 activities
    if (this.activities.length > 50) {
      this.activities = this.activities.slice(0, 50);
    }

    this.saveActivities();
    return activity;
  }

  getRecentActivities(limit = 10) {
    return this.activities.slice(0, limit);
  }

  getActivityIcon(type) {
    const icons = {
      news: 'NewspaperIcon',
      match: 'CalendarIcon',
      standing: 'TrophyIcon'
    };
    return icons[type] || 'DocumentIcon';
  }

  getActivityColor(type) {
    const colors = {
      news: 'bg-blue-500',
      match: 'bg-green-500',
      standing: 'bg-yellow-500'
    };
    return colors[type] || 'bg-gray-500';
  }

  getActivityText(activity) {
    const { type, action, details } = activity;
    
    const actionTexts = {
      created: 'დაემატა',
      updated: 'განახლდა',
      deleted: 'წაიშალა',
      published: 'გამოქვეყნდა',
      unpublished: 'დამალული გახდა'
    };

    const typeTexts = {
      news: 'ამბავი',
      match: 'მატჩი',
      standing: 'გუნდი'
    };

    const actionText = actionTexts[action] || action;
    const typeText = typeTexts[type] || type;

    if (details.title) {
      return `${typeText} "${details.title}" ${actionText}`;
    }

    return `${typeText} ${actionText}`;
  }

  formatTimeAgo(timestamp) {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInSeconds = Math.floor((now - time) / 1000);

    if (diffInSeconds < 60) {
      return 'ახლახან';
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} წუთის წინ`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} საათის წინ`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
      return `${diffInDays} დღის წინ`;
    }

    const diffInWeeks = Math.floor(diffInDays / 7);
    return `${diffInWeeks} კვირის წინ`;
  }
}

// Create singleton instance
const activityService = new ActivityService();

// Export functions for easy use
export const addActivity = (type, action, details) => activityService.addActivity(type, action, details);
export const getRecentActivities = (limit) => activityService.getRecentActivities(limit);
export const getActivityIcon = (type) => activityService.getActivityIcon(type);
export const getActivityColor = (type) => activityService.getActivityColor(type);
export const getActivityText = (activity) => activityService.getActivityText(activity);
export const formatTimeAgo = (timestamp) => activityService.formatTimeAgo(timestamp);

export default activityService;

